import React from "react";

function Contact() {
  return (
    <div className="container two-column">
      <div>
        <h2 className="section-title">Contact Us</h2>
        <p>For club inquiries, session bookings, or general questions:</p>
        <ul className="bullet-list">
          <li>
            <strong>Email:</strong>{" "}
            <a href="mailto:beyondbaddy@gmail.com">beyondbaddy@gmail.com</a>
          </li>
          <li>
            <strong>Email For Coaching Enquiry:</strong>{" "}
            <a href="mailto:bbijuniorcoaching@gmail.com">bbijuniorcoaching@gmail.com</a>
          </li>
          <li><strong>Facebook:</strong> <a href="https://www.facebook.com/profile.php?id=61577669670370" target="_blank" rel="noopener noreferrer">facebook.com/beyond-badminton</a></li>
          <li><strong>WhatsApp Groups:</strong>
            <ul style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>
              <li><strong>Members-only group :  </strong> Access will be granted after joining the club as a member</li>
              <li><strong>Casual group pool :  </strong><a href="https://chat.whatsapp.com/FDghyI9TQD0KY6HFsc22r7?mode=gi_t">Join here</a></li>
            </ul>
          </li>
        </ul>
      </div>
      <div>
        <h3>Venue</h3>
        <p>
          Lake Haven Recreation Centre
          <br />
          Forrow Dr, Lake Haven NSW 2263
        </p>
        <p className="muted">
          You can also message us on Facebook for the latest updates and session information.
        </p>
      </div>
    </div>
  );
}

export default Contact;
